export const dimensionsData = {
	'revv-1': {
		general: [
			{ option: 'Weight Capacity', value: '350lbs' },
			{ option: 'Rider Height Range', value: `5'2" - 6'4"` },
		],
		FS: [
			{ option: 'Total Weight', value: '93lbs' },
			{ option: 'Handlebar Height', value: `40.5”` },
			{ option: 'Handlebar Reach', value: `14.75”` },
			{ option: 'Seat Height', value: `32.5”` },
			{ option: 'Stand-Over Height', value: `32.5”` },
			{ option: 'Wheel Base', value: `49”` },
			{ option: 'Total Length', value: `72”` },
		],
		HT: [
			{ option: 'Total Weight', value: '83lbs' },
			{ option: 'Handlebar Height', value: `40.5”` },
			{ option: 'Handlebar Reach', value: `14.75”` },
			{ option: 'Seat Height', value: `32.5”` },
			{ option: 'Stand-Over Height', value: `32.5”` },
			{ option: 'Wheel Base', value: `44”` },
			{ option: 'Total Length', value: `69”` },
		],
		image: '/Dimensions/Revv1-Dimensions-01.png',
	},
	'700-series': {
		general: [
			{ option: 'Weight', value: '(with rack and fenders) 62lbs' },
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Total Length', value: `70"` },
			{ option: 'Wheel Base', value: `43"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'-6'2"` },
			{ option: 'Handlebar Height', value: `40”` },
			{ option: 'Handlebar Reach', value: `18”` },
			{ option: 'Maximum Seat Height', value: `38”` },
			{ option: 'Minimum Seat Height', value: `31”` },
			{ option: 'Stand-over Height', value: `17”` },
			{ option: 'Seat Tube', value: `18”` },
		],
		XR: [
			{ option: 'Rider Height Range', value: `5'5"-6'4"` },
			{ option: 'Handlebar Height', value: `41”` },
			{ option: 'Handlebar Reach', value: `22”` },
			{ option: 'Maximum Seat Height', value: `40”` },
			{ option: 'Minimum Seat Height', value: `33”` },
			{ option: 'Stand-over Height', value: `29.5”` },
			{ option: 'Seat Tube', value: `19”` },
		],
		image: '/Dimensions/700-Dimensions.png',
	},
	cruiser: {
		general: [
			{ option: 'Weight', value: '65lbs' },
			{ option: 'Weight Capacity', value: '350lbs' },
			{ option: 'Total Length', value: `76"` },
			{ option: 'Wheel Base', value: `48"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'-6'4"` },
			{ option: 'Handlebar Height', value: `41”` },
			{ option: 'Handlebar Reach', value: `20”` },
			{ option: 'Maximum Seat Height', value: `38”` },
			{ option: 'Minimum Seat Height', value: `31”` },
			{ option: 'Stand-over Height', value: `22.5”` },
			{ option: 'Seat Tube', value: `16.5”` },
		],
		XR: [
			{ option: 'Rider Height Range', value: `5'5"-6'4"` },
			{ option: 'Handlebar Height', value: `41”` },
			{ option: 'Handlebar Reach', value: `20”` },
			{ option: 'Maximum Seat Height', value: `40”` },
			{ option: 'Minimum Seat Height', value: `33”` },
			{ option: 'Stand-over Height', value: `28.5”` },
			{ option: 'Seat Tube', value: `18”` },
		],
		image: '/Dimensions/Cruiser-Dimensions.png',
	},
	'core-5': {
		general: [
			{ option: 'Weight', value: '49lbs' },
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Seat Tube', value: `19”` },
			{ option: 'Minimum Seat Height', value: `32" ` },
			{ option: 'Maximum Seat Height', value: `40”` },
			{ option: 'Total Length', value: `70"` },
			{ option: 'Wheel Base', value: `43"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'0"-6'1"` },
			{ option: 'Stand-over Height', value: `19”` },
			{ option: 'Handlebar Height', value: `41”` },
			{ option: 'Handlebar Reach', value: `18”` },
		],
		XR: [
			{ option: 'Rider Height Range', value: `5'6"-6'4"` },
			{ option: 'Stand-over Height', value: `28.5”` },
			{ option: 'Handlebar Height', value: `42”` },
			{ option: 'Handlebar Reach', value: `22”` },
		],
		image: '/Dimensions/Core-Dimensions.png',
	},
	lmtd: {
		general: [
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Weight', value: '53lbs' },
			{ option: 'Seat Tube', value: `19”` },
			{ option: 'Minimum Seat Height', value: `32" ` },
			{ option: 'Maximum Seat Height', value: `40”` },
			{ option: 'Wheel Base', value: `43"` },
			{ option: 'Total Length', value: `70"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'1"-6'2"` },
			{ option: 'Stand-over Height', value: `18”` },
			{ option: 'Handlebar Reach', value: `16”` },
			{ option: 'Handlebar Height', value: `40”` },
		],
		XR: [
			{ option: 'Rider Height Range', value: `5'6"-6'4"` },
			{ option: 'Stand-over Height', value: `29”` },
			{ option: 'Handlebar Reach', value: `20”` },
			{ option: 'Handlebar Height', value: `42”` },
		],
		image: '/Dimensions/Lmtd-Dimensions.png',
	},
	prodigy: {
		general: [
			{ option: 'Weight', value: '50lbs' },
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Seat Tube', value: `19”` },
			{ option: 'Minimum Seat Height', value: `32" ` },
			{ option: 'Maximum Seat Height', value: `40”` },
			{ option: 'Handlebar Height', value: `42”` },
			{ option: 'Wheel Base', value: `43"` },
			{ option: 'Total Length', value: `71"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'1"-6'3"` },
			{ option: 'Stand-over Height', value: `18”` },
			{ option: 'Handlebar Reach', value: `20”` },
		],
		XC: [
			{ option: 'Rider Height Range', value: `5'6"-6'4"` },
			{ option: 'Stand-over Height', value: `29”` },
			{ option: 'Handlebar Reach', value: `20”` },
		],
		XR: [
			{ option: 'Rider Height Range', value: `5'6"-6'4"` },
			{ option: 'Stand-over Height', value: `29”` },
			{ option: 'Handlebar Reach', value: `20”` },
		],
	},
	rift: {
		general: [
			{ option: 'Weight Capacity', value: '350lbs' },
			{ option: 'Weight', value: '84.5lbs' },
			{ option: 'Seat Tube', value: `17”` },
			{ option: 'Minimum Seat Height', value: `33.5" ` },
			{ option: 'Maximum Seat Height', value: `44”` },
			{ option: 'Wheel Base', value: `46.4"` },
			{ option: 'Total Length', value: `75.4"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'1"-6'2"` },
			{ option: 'Stand-over Height', value: `19”` },
			{ option: 'Handlebar Reach', value: `15”` },
			{ option: 'Handlebar Height', value: `42.5”` },
		],

		XR: [
			{ option: 'Rider Height Range', value: `5'6"-6'4"` },
			{ option: 'Stand-over Height', value: `29.5”` },
			{ option: 'Handlebar Reach', value: `15”` },
			{ option: 'Handlebar Height', value: `42.5”` },
		],
		image: '/Dimensions/Rift-Dimensions.png',
	},
	'roadster-v2': {
		general: [
			{ option: 'Weight', value: '33lbs' },
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Wheel Base', value: `43"` },
			{ option: 'Total Length', value: `68.5"` },
		],
		Small: [
			{ option: 'Rider Height Range', value: `5'3"-5'8"` },
			{ option: 'Handlebar Height', value: `36”` },
			{ option: 'Handlebar Reach', value: `25”` },
			{ option: 'Maximum Seat Height', value: `41”` },
			{ option: 'Minimum Seat Height', value: `33" ` },
			{ option: 'Stand-over Height', value: `30.5”` },
			{ option: 'Seat Tube', value: `20”` },
		],

		Large: [
			{ option: 'Rider Height Range', value: `5'8"-6'3"` },
			{ option: 'Handlebar Height', value: `38”` },
			{ option: 'Handlebar Reach', value: `26”` },
			{ option: 'Maximum Seat Height', value: `43”` },
			{ option: 'Minimum Seat Height', value: `36" ` },
			{ option: 'Stand-over Height', value: `33”` },
			{ option: 'Seat Tube', value: `22”` },
		],
		image: '/Dimensions/Roadster-Dimensions.png',
	},
	turris: {
		general: [
			{ option: 'Weight Capacity', value: '300lbs' },
			{ option: 'Weight', value: '55lbs' },
			{ option: 'Seat Tube', value: `19”` },
			{ option: 'Minimum Seat Height', value: `32" ` },
			{ option: 'Maximum Seat Height', value: `42.5”` },
			{ option: 'Wheel Base', value: `43"` },
			{ option: 'Total Length', value: `71.5"` },
		],
		ST: [
			{ option: 'Rider Height Range', value: `5'1"-6'2"` },
			{ option: 'Stand-over Height', value: `19”` },
			{ option: 'Handlebar Reach', value: `15”` },
			{ option: 'Handlebar Height', value: `42.5”` },
		],

		XR: [
			{ option: 'Rider Height Range', value: `5'1"-6'2"` },
			{ option: 'Stand-over Height', value: `23”` },
			{ option: 'Handlebar Reach', value: `15.5”` },
			{ option: 'Handlebar Height', value: `44.5”` },
		],
		image: '/Dimensions/Turris-Dimensions.png',
	},
};
